import { render, staticRenderFns } from "./r-item-trader-mode.vue?vue&type=template&id=7e805343"
import script from "./r-item-trader-mode.vue?vue&type=script&lang=js"
export * from "./r-item-trader-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e805343')) {
      api.createRecord('7e805343', component.options)
    } else {
      api.reload('7e805343', component.options)
    }
    module.hot.accept("./r-item-trader-mode.vue?vue&type=template&id=7e805343", function () {
      api.rerender('7e805343', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/trader/r-item-trader-mode.vue"
export default component.exports